import React from 'react';
import style from './_attachments.scss';
import CONFIG from 'base/constants/config';

class Attachments extends React.Component {
  render() {
    return (
      <div className='attachment-container'>
        <ul className="file-list">
          {
            this.props.files.map((file, index) => {
              return (
                <li key={index}><a target="_blank" href={`${CONFIG.API_URL}/containers/demands/download/${file}`}>File {index + 1}</a></li>
              );
            })
          }
        </ul>

      </div>
    );
  }
}

export default Attachments;



// WEBPACK FOOTER //
// ./components/conversations/Attachments.jsx